import service from '@/utils/request' // 引入之前封装的 Axios 实例
import * as http from '@/utils/request'


// 获取学校学院专业
export const GetSchoolCollegeMajorApi = (data) => {
    return http.get('/admin/AttestationXY/GetSchoolCollegeMajor', data)
}

// 导出历史列表
export const ExportHistoryAttestationXYApi = (data) => {
    return http.get('/admin/AttestationXY/ExportHistoryAttestationXY', data)
}

// 获取待申核返校预约列表
export const GetReturnSchoolPrebooksWaitAuditApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/GetReturnSchoolPrebooksWaitAudit', data)
}

// 获取返校预约记录
export const GetReturnSchoolPrebooksRecordApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/GetReturnSchoolPrebooksRecord', data)
}

// 获取返校预约记录详情
export const GetReturnSchoolPrebookInfoApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/GetReturnSchoolPrebookInfo', data)
}

// 获取返校审核
export const AuditReturnSchoolPrebookApi = (data) => {
    return http.post('/admin/ReturnSchoolPrebook/AuditReturnSchoolPrebook', data)
}

//返校预约设置
export const SetReturnSchoolPrebookApi = (data) => {
    return http.post('/admin/ReturnSchoolPrebook/SetReturnSchoolPrebook', data)
}

//获取返校预约设置
export const GetReturnSchoolPrebookSetApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/GetReturnSchoolPrebookSet', data)
}

//返校预约总数
export const ReturnSchoolPrebookCountApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolPrebookCount', data)
}

//当日预约总数
export const PrebookTodeyApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/PrebookTodey', data)
}

//当日返校统计
export const ReturnSchoolTodeyApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolTodey', data)
}

//预约返校数据趋势
export const ReturnSchoolPrebookTrendApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolPrebookTrend', data)
}

//学院返校统计
export const ReturnSchoolByCollegeApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolByCollege', data)
}

//各届校友返校人数统计
export const ReturnSchoolByYearApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolByYear', data)
}

//返校行业排行
export const ReturnSchoolByWorkFieldApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolByWorkField', data)
}

//返校校友男女比例
export const ReturnSchoolByGenderApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/ReturnSchoolByGender', data)
}

//学院预约统计
export const PrebookByCollegeApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/PrebookByCollege', data)
}

//各届校友预约人数统计
export const PrebookByYearApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/PrebookByYear', data)
}

//预约行业排行
export const PrebookByWorkFieldApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/PrebookByWorkField', data)
}

//预约校友男女比例
export const PrebookByGenderApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/PrebookByGender', data)
}

//简历详情
export const ResumeUserApi = (data) => {
    return http.get('/app/User/ResumeUser', data)
}

//心愿列表
export const GetWishListAsync_adminApi = (data) => {
    return http.get('/app/My/GetWishListAsync_admin', data)
}

//心愿详情
export const GetWishInfo_adminApi = (data) => {
    return http.get('/app/My/GetWishInfo_admin', data)
}

// 心愿详情开启关闭
export const SetIsNM_adminApi = (data) => {
    return http.post('/app/My/SetIsNM_admin', data)
}

//心愿状态
export const CheckNMApi = (data) => {
    return http.get('/app/My/CheckNM', data)
}

//简历附件
export const GetUserFileApi = (data) => {
    return http.get('/app/User/GetUserFile', data)
}

//获取权限
export const GetPowerApi = (data) => {
    return http.get('/admin/User/GetPower', data)
}

//获取当前用户权限
export const GetUserPowerApi = (data) => {
    return http.get('/admin/User/GetUserPower', data)
}

//修改当前用户权限
export const UpdateUserPowerApi = (data) => {
    return http.post('/admin/User/UpdateUserPower', data)
}

//获取学校设置列表
export const GetNM_adminApi = (data) => {
    return http.get('/app/My/GetNM_admin', data)
}

//获取返校预约设置列表
export const GetReturnSchoolPrebookSetListApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/GetReturnSchoolPrebookSetList', data)
}

//获取返校预约设置列表详情
export const GetReturnSchoolPrebookSetInfoApi = (data) => {
    return http.get('/admin/ReturnSchoolPrebook/GetReturnSchoolPrebookSetInfo', data)
}

//获取已认证的学校
export const GetAttestationSchoolListApi = (data) => {
    return http.get('/admin/User/GetAttestationSchoolList', data)
}

//切换学校
export const SelectSchoolApi = (data) => {
    return http.post('/admin/User/SelectSchool', data)
}

//获取管理员列表
export const GetAdminListApi = (data) => {
    return http.get('/api/AdminManagement/GetAdminList', data)
}

//添加管理员
export const AddAdminApi = (data) => {
    return http.post('/api/AdminManagement/AddAdmin', data)
}

//校验学校是否有校级管理员
export const GetThisSchoolLevelAdminSituationApi = (data) => {
    return http.get('/api/AdminManagement/GetThisSchoolLevelAdminSituation', data)
}

//校验学校是否有相同账号
export const DetermineThisAdminExistsApi = (data) => {
    return http.post('/api/AdminManagement/DetermineThisAdminExists', data)
}

//获取本校校级管理员
export const GetThisSchoolTeacherDataApi = (data) => {
    return http.get('/api/AdminManagement/GetThisSchoolTeacherData', data)
}

//转让教职工
export const TransferOfIdentityApi = (data) => {
    return http.post('/api/AdminManagement/TransferOfIdentity', data)
}

//通过手机号获取管理员
export const GetUserDataApi = (data) => {
    return http.get('/api/AdminManagement/GetUserData', data)
}

//获取领域列表
export const GetWorkFieldsApi = (data) => {
    return http.get('/admin/WorkField/GetWorkFields', data)
}

//获取领域列表
export const GetSubWorkFieldsApi = (data) => {
    return http.get('/admin/WorkField/GetSubWorkFields', data)
}

//添加子领域
export const AddSubWorkFieldApi = (data) => {
    return http.post('/admin/WorkField/AddSubWorkField', data)
}

//获取行业列表
export const GetWorkFieldJobsApi = (data) => {
    return http.get('/admin/WorkField/GetWorkFieldJobs', data)
}

//添加行业方向
export const AddtWorkFieldJobApi = (data) => {
    return http.post('/admin/WorkField/AddtWorkFieldJob', data)
}

//获取领域模版
export const WorkFieldTemplateApi = (data) => {
    return http.get('/admin/WorkField/WorkFieldTemplate', data)
}

//获取预配置用户表
export const GetPreConfiguredUserListApi = (data) => {
    return http.get('/admin/PreConfiguredUser/GetPreConfiguredUserList', data)
}

//获取预配置导入模版
export const PreConfiguredUserTemplateApi = (data) => {
    return http.get('/admin/PreConfiguredUser/PreConfiguredUserTemplate', data)
}

//预配置导入
export const ImportPreConfiguredUserApi = (data) => {
    return http.post('/admin/PreConfiguredUser/ImportPreConfiguredUser', data)
}

//删除预配置用户
export const DeletePreConfiguredUserApi = (data) => {
    return http.post('/admin/PreConfiguredUser/DeletePreConfiguredUser', data)
}

//添加资讯封面
export const AddJournaArticleCoverReq = (data) => {
    return http.post('/admin/Article/AddJournaArticleCover', data)
}

//修改资讯封面
export const UpdateJournaArticleCoverReq = (data) => {
    return http.post('/admin/Article/UpdateJournaArticleCover', data)
}

//禁/启用资讯封面
export const DisableOrEnableJournaArticleCoverReq = (data) => {
    return http.post('/admin/Article/DisableOrEnableJournaArticleCover', data)
}

//获取预配置导入模版
export const GetJournaArticleCoverListReq = (data) => {
    return http.get('/admin/Article/GetJournaArticleCoverList', data)
}

//发布资讯
export const PublishJournaArticleApi = (data) => {
    return http.post('/admin/Article/PublishJournaArticle', data)
}


// WEBPACK FOOTER //
// ./src/request/requestApi.js